import { createGlobalState } from "react-hooks-global-state";

export const { 
    setGlobalState: setBalance, 
    useGlobalState: useBalance 
} = createGlobalState({
    uusd: 0,
    uluna: 0,
    eth: 0,
    bnb: 0,
});

export const {
    setGlobalState: setChainAddress,
    useGlobalState: useChainAddress,
} = createGlobalState({
    address: "",
    network: "",
});